<template>
  <div
    class="pix-guide"
  >
    <div class="pix-container">
      <div :class="['pix-qr_code-wrapper', { skeleton: loading }]">
        <QRCode
          v-if="pixCode"
          :value="pixCode"
          class="pix-qr_code"
        />
      </div>
      <BulletList />
    </div>
    <span class="pix-qr_code-description">
      Escaneie o código acima ou
    </span>

    <v-popover
      class="mobile-button_wrapper"
      :offset="16"
      placement='top'
      :show="showTooltipCopied"
      :disabled="!showTooltipCopied"
    >
      <Button
        class="primary mb-20 mobile-button"
        content="Copiar código Pix"
        :hasIcon="true"
        :iconName="'copy-white.svg'"
        @click="copyText(pixCode), sendEvent({
          action: 'copiou-codigo-pix',
          data: {
            pixCode
          }
        })"
      />
      <template slot="popover">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-text">
          Código copiado
        </div>
      </template>
    </v-popover>

    <v-popover
      class="desktop-button_wrapper"
      :offset="16"
      placement='top'
      :show="showTooltipCopied"
      :disabled="!showTooltipCopied"
    >
      <Button
        class="copy-code-button desktop-button"
        content="Copiar código"
        :hasIcon="true"
        :iconName="'copy.svg'"
        @click="copyText(pixCode), sendEvent({
          action: 'copiou-codigo-pix',
          data: {
            pixCode
          }
        })"
      />
      <template slot="popover">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-text">
          Código copiado
        </div>
      </template>
    </v-popover>

    <p class="billet-body--pix_paragraph">
      O pagamento por PIX pode demorar até 24 horas para ser confirmado.
    </p>
  </div>
</template>

<script>
import Vue from 'vue';
import VTooltip from 'v-tooltip';
import QRCode from '@/components/common/QRCode.vue';
import BulletList from './BulletList.vue';
import Button from './Button.vue';
import ParcelexApi from '../../../services/parcelex';

Vue.use(VTooltip);

export default {
  components: {
    QRCode,
    Button,
    BulletList,
  },
  name: 'PixDescription',
  props: {
    pixCode: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      requred: true,
    },
  },
  data: () => ({
    showTooltipCopied: false,
  }),
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
      this.showTooltipCopied = true;
      setTimeout(() => {
        this.showTooltipCopied = false;
      }, 2000);
    },
    async sendEvent({ action, data }) {
      const { query } = this.$route;

      ParcelexApi.post('public/event/send', {
        action,
        source: 'billet-page',
        origin: window.location.href.split('?')[0],
        data: {
          ...data,
          ...query,
        },
      }).catch((e) => console.error(e));
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/__new-styles.scss';

  .pix-guide {
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .pix-container {
    display: flex;
    justify-content: space-between;
  }
  .pix-qr_code-wrapper {
    display: none;

    height: 204px;
    min-height: 204px;
    width: 204px;
    min-width: 204px;

    margin-right: 20px;
    margin-bottom: 12px;

    @media (min-width: $lg) {
      display: inline-block;
    }
  }
  .pix-qr_code {
    display: none;
    height: 204px;
    min-height: 204px;
    width: 204px;
    min-width: 204px;
    border: 1px solid var(--gray-200);
    border-radius: 8px;

    @media (min-width: $lg) {
      display: inline-block;
    }
  }
  .pix-qr_code-description {
    @extend .small-regular;
    font-family: var(--font-family);
    line-height: 20px;
    padding-left: 13px;
    margin-bottom: 12px;
    align-self: start;
    display: none;

    @media (min-width: $lg) {
      display: inline-block;
    }
  }
  .mobile-button_wrapper {
    width: 100%;

    @media (min-width: $lg) {
      display: none;
    }
  }
  .mobile-button {
    display: inline-block;

    @media (min-width: $lg) {
      display: none;
    }
  }
  .desktop-button_wrapper {
    display: none;

    @media (min-width: $lg) {
      display: inline-block;
      width: 100%;
    }
  }
  .desktop-button {
    display: none;

    @media (min-width: $lg) {
      max-width: fit-content;
      display: flex;
      margin-left: 20px;
      margin-right: 20px;
      align-self: start;
    }
  }
  .billet-body--pix_paragraph {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    font-family: var(--font-family);
    color: var(--gray-500);

    @media (min-width: $lg) {
      font-size: 14px;
      align-self: start;
      line-height: 20px;
    }
  }
  .v-popover ::v-deep .trigger{
    width: 100% !important;

    @media (min-width: $lg) {
      width: unset !important;
    }
  }
  .tooltip {
    display: block !important;
    z-index: 2;

    .tooltip-text {
      background: var(--gray-600);
      color: white;
      border-radius: 4px;
      padding: 4px 8px 4px 8px;
      text-align: center;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 1px;
      border-color: var(--gray-600);
      z-index: 1;
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  }

  .copy-code-button {
    margin-bottom: 20px;
    background-color: var(--white);
    border:1px solid var(--gray-300);

    &:hover {
      background-color: var(--white) !important;
      border: 1px solid var(--blue-300) !important;
    }
  }
</style>

<style lang="scss">
  .copy-code-button {
    p.white {
      color: var(--gray-700) !important;
      font-weight: 400 !important;
    }

    &:hover {
      p.white {
        color: var(--primary) !important;
      }

      img {
        filter:
          invert(52%)
          sepia(73%)
          saturate(434%)
          hue-rotate(149deg)
          brightness(94%)
          contrast(86%);
      }
    }
  }
</style>
